import React, { useState } from 'react';
import { Flex, Skeleton, ThemePrepared, ChevronEndIcon, ChevronDownIcon } from '@fluentui/react-northstar';
import { Ticket } from '../../interfaces/ticket.interface';
import { useTranslation } from 'react-i18next';
import { TicketCustomFormSection } from '../TicketCustomFormTab/TicketCustomFormSection';

interface Props {
  isOpen: boolean;
  isDisabled: boolean;
  onCLose: (value: boolean) => void;
  primaryButtonColor: string;
  isSaving: boolean;
  globalTheme: ThemePrepared<any>;
  ticketId: number;
  parentData?: Ticket;
  isEndUserForm?: boolean;
  dispatchEvent?: any;
  setAppState?: any;
  showUpdateAnswerButton?: boolean;
  onInteraction?: any;
  loadingTicketData: boolean;
}

export const EditTicketCustomFormAnswers = ({
  isOpen,
  isDisabled,
  onCLose,
  primaryButtonColor,
  isSaving,
  globalTheme,
  ticketId,
  parentData,
  isEndUserForm,
  dispatchEvent,
  setAppState,
  showUpdateAnswerButton,
  onInteraction,
  loadingTicketData
}: Props) => {
  const {t} = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const parentTemplate = parentData["Template"] || parentData;
  const noForm = parentData?.TemplateId <= 0 || parentTemplate["NoCustomForm"]
  const getColor = () => {
    const theme = globalTheme.siteVariables.colorScheme;
    return noForm ? theme.default.foregroundDisabled : theme.default.foreground
  }
  return (
    <>
      <Flex
        vAlign="center"
        space="between"
        className={`mt-7 pb-4 cursor-pointer`}
        onClick={() => {
          if(!noForm) {
            localStorage.setItem('ticket_detail_custom_form_answers_accordion_open', (!isOpen).toString());
          }
          onCLose(!isOpen)
        }}
        style={{
          borderBottom: !noForm && isOpen ? `1px solid ${primaryButtonColor}` : 'none',
          pointerEvents: parentData?.TemplateId <= 0 || parentTemplate["NoCustomForm"] ? 'none' : 'auto',
          color: `${getColor()}`
        }}
      >
        <Flex gap="gap.small" vAlign="center">
          {!noForm && isOpen ? <ChevronDownIcon style={{ color:`${getColor()}`}} /> : <ChevronEndIcon style={{ color:`${getColor()}`}} /> }
          <Flex style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px' }} >
            {t('ticket-details.edit-ticket-form.custom-form-answer.title')}
          </Flex>
        </Flex>
      </Flex>

      {!noForm && isOpen && <>
        {(isLoading || loadingTicketData) && (
          <>
            <Skeleton animation="wave">
              <TicketCustomFormSection
                customForms = {parentData.CustomForms}
                showUpdateAnswerButton = { showUpdateAnswerButton ?? true}
                ticketId={ticketId}
                setAppStateEvent = {setAppState}
                dispatchEvent = {dispatchEvent}
                template = {parentTemplate}
                disabledFormInputs = {isDisabled}
                onInteraction={onInteraction}
              ></TicketCustomFormSection>
            </Skeleton>
          </>
        )}
      </>}
    </>
  );
};
